import axios, { resHandle } from "@/plugins/axios";


/**
 * @description 获取患者列表
 * @param vCom Vue组件
 * @param params 参数
 */
const GetPatientsList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/yjdl/patients", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获得分中心列表
 * @param vCom Vue组件
 */
const GetHospitals = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/user/hospitals", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获得分中心列表(不需要参数)
 * @param vCom Vue组件
 */
const GetHospitalsNoSearch = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/user/hospitals").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 添加患者
 * @param vCom Vue组件
 */
const CreatePatient = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获得左侧列表
 * @param vCom Vue组件
 */
const GetLeftNav = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/yjdl/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 个人信息详情
 * @param vCom Vue组件
 */
const GetPatientInfo = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 模板详情
 * @param vCom Vue组件
 */
const GetTemplates = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/template", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 数据详情
 * @param vCom Vue组件
 */
const GetContents = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/contents", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 修改患者
 * @param vCom Vue组件
 */
const PutUpdatePatient = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.put("api/project/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获取创建Oss的初始参数
 * @param vCom Vue组件
 */
const GetOssParams = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        const params: any = {
            params: {
                type: "file"
            }
        };
        axios.get("api/oss", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 临床科室数据中心数据导出
 * @param vCom Vue组件
 */
const PostDataExport = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/export/lincenter", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 数据导出：模板列表（导出页面右边的接口）
 * @param vCom Vue组件
 */
const GetDataExportTemplates = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/data/table/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


export {
    GetPatientsList, GetHospitals, GetHospitalsNoSearch, CreatePatient, GetLeftNav, GetPatientInfo, PutUpdatePatient,
    GetTemplates, GetContents, GetOssParams, PostDataExport, GetDataExportTemplates
};
